import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import { RoundButton } from '../ui-toolkit/buttons';

const isOpen = status => status === 'OPEN';

const ChallengeTimer = ({ classNames, status, deadline }) => (
	<RoundButton className={classNames}>
		<i className="material-icons">access_time</i>

		{isOpen(status) && deadline && moment(deadline).fromNow()}
		{!isOpen(status) && (
			<FormattedMessage id={`challenge.status_${status.toLowerCase()}`} />
		)}
	</RoundButton>
);

export default ChallengeTimer;
